import React from 'react'
import styled from 'styled-components'
import Avatar from 'components/Avatar'
import { Flex } from 'components/Box'

const Border = styled.div`
  display: flex;
  flex-direction: row;
  border: 1px solid ${({ theme }) => theme.colors.border.dark.high};
  align-items: center;
  padding: 4px;
  border-radius: 999px;
`

const Email = styled.span`
  color: ${({ theme }) => theme.colors.text.dark.base};
  font-size: 1rem;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  margin: 0 12px;
`

interface UserChipProps {
  name: string
  email: string
  avatarSrc?: string
}

const UserChip = ({ name, email, avatarSrc }: UserChipProps) => {
  return (
    <Flex
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      margin={6}>
      <Border>
        <Avatar name={name} src={avatarSrc} />
        <Email>{email}</Email>
      </Border>
    </Flex>
  )
}

export default UserChip
